import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import CategoryItemCreateComponent from "../../components/CategoryItem/CategoryItemCreate";
import { connect } from 'react-redux';
import { viewCategoryAction } from "../../actions";
import { useParams } from "react-router-dom";

function CategoryCreate({ viewCategoryAction }) {
    const [category, setCategoryData] = useState(null);
    const params = useParams();
    const id = params.categoryId;
    useEffect(() => {
        viewCategoryAction({ id: id }, (err, response) => {
            setCategoryData(response.data.data);
        })
    }, [id]);

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    {category && <PageHeader
                        HeaderText="Category Create"
                        Breadcrumb={[
                            { name: "Categories", navigate: "/categories" },
                            { name: category.title, navigate: `/category-item/view/${category._id}` },
                            { name: "Sub Category Items", navigate: `/sub-category-item/${category._id}` },
                            { name: "Sub Category Create", navigate: `` },
                        ]}
                    />}
                    <div className="row clearfix">
                        {category && <CategoryItemCreateComponent category={category} />}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { viewCategoryAction })(CategoryCreate)